import { render, staticRenderFns } from "./ComparisonItem.vue?vue&type=template&id=78f9feae&"
import script from "./ComparisonItem.vue?vue&type=script&lang=js&"
export * from "./ComparisonItem.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports